import { render, staticRenderFns } from "./noContent.vue?vue&type=template&id=9966eab0&scoped=true"
import script from "./noContent.vue?vue&type=script&lang=js"
export * from "./noContent.vue?vue&type=script&lang=js"
import style0 from "./noContent.vue?vue&type=style&index=0&id=9966eab0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9966eab0",
  null
  
)

export default component.exports